import { Stack, Typography, Button, type TooltipProps } from '@mui/material'

import { CustomTooltip } from '@/components/ui/tooltip'

export function InfoTooltip({
  children,
  CTA,
  title: titleText,
  description,
  placement = 'top',
  style,
}: {
  children: any
  title: string
  description?: string
  CTA?: {
    label: string
    onClick: () => void
  }
  placement?: TooltipProps['placement']
  style?: React.CSSProperties
}) {
  return (
    <CustomTooltip
      placement={placement}
      style={style}
      sx={{
        height: '100%',

        '& > div': {
          height: '100%',
        },
      }}
      title={
        <Stack gap="8px">
          <Typography color="#475467" variant="xs">
            {titleText}
          </Typography>
          {description ? (
            <Typography color="#101828" fontWeight="semibold" variant="xs">
              {description}
            </Typography>
          ) : null}
          {CTA ? (
            <Button
              sx={{
                width: 'fit-content',
                padding: '4px 8px',
                fontSize: 12,
              }}
              variant="contained"
              onClick={CTA.onClick}
            >
              {CTA.label}
            </Button>
          ) : null}
        </Stack>
      }
    >
      {children}
    </CustomTooltip>
  )
}
